// Event list — keyed by list key: "calendar" for the month grid, "day:YYYY-MM-DD" for a
// Daily Event sidebar.
export const EVENT_ACTION_GET_EVENT_LIST = 'CAL_EVENT_ACTION_GET_EVENT_LIST'
export const EVENT_SET_FETCHING_EVENT_LIST = 'CAL_EVENT_SET_FETCHING_EVENT_LIST'
export const EVENT_SET_EVENT_LIST = 'CAL_EVENT_SET_EVENT_LIST'
// Re-runs every list slice with its last-used request args — dispatched after a
// create/update/delete so the month grid and any open Daily sidebar stay fresh without
// threading callbacks through showSideBar (which serialises viewProps to query params).
export const EVENT_ACTION_REFRESH_LISTS = 'CAL_EVENT_ACTION_REFRESH_LISTS'

// Single event record — keyed by eventKey (uid) for the detail / edit sidebar.
export const EVENT_ACTION_GET_EVENT = 'CAL_EVENT_ACTION_GET_EVENT'
export const EVENT_ACTION_REFRESH_EVENT = 'CAL_EVENT_ACTION_REFRESH_EVENT'
export const EVENT_SET_FETCHING_EVENT = 'CAL_EVENT_SET_FETCHING_EVENT'
export const EVENT_SET_EVENT = 'CAL_EVENT_SET_EVENT'

export const EVENT_ACTION_CREATE_EVENT = 'CAL_EVENT_ACTION_CREATE_EVENT'
export const EVENT_ACTION_UPDATE_EVENT = 'CAL_EVENT_ACTION_UPDATE_EVENT'
export const EVENT_ACTION_DELETE_EVENT = 'CAL_EVENT_ACTION_DELETE_EVENT'
